import React, { ReactNode, useState } from 'react';

import { useIntl } from 'react-intl';
import { messages } from '../../../../../../../../../components/screens/SubmitCredentials/messages';
import { LoginTitleHeader } from '../../../../../../../../../components/screens/molecules/SubmitCredentialsScreen/screens/LegacySubmitCredentialsScreenView/LoginTitleHeader';
import { SubmitProviderInputsPayload } from '../../../../../../../../../components/screens/SubmitCredentials/molecules/ProviderInputs/ProviderInputs';
import {
  HeaderContainer,
  StyledError,
  StyledUserHintId,
} from '../../../../../../../../../components/screens/molecules/SubmitCredentialsScreen/SubmitCredentialsScreen.styles';
import { ProviderTitleHeader } from '../../../../../../../../../components/screens/molecules/SubmitCredentialsScreen/screens/LegacySubmitCredentialsScreenView/ProviderTitleHeader';
import { Provider, ProviderEntity } from '../../../../../../../../../models/provider';
import { ContentBody } from '../../../../../../../../../components/atoms/ContentBody/ContentBody';
import { ProviderInputsWrapper } from '../../../../../../../../../components/screens/SubmitCredentials/molecules/ProviderInputs/ProviderInputsWrapper';
import { ApplicationUnverifiedLabel } from '../../../../../../../../../components/molecules/ApplicationUnverifiedLabel/ApplicationUnverifiedLabel';
import { Footer } from '../../../../../../../../../components/atoms/Footer/Footer';
import { LoadingSpinner } from '../../../../../../../../../components/atoms/LoadingSpinner/LoadingSpinner';
import { Button } from '../../../../../../../../../components/atoms/Button/Button';

type LoginTemplatePayScreenViewProps = {
  credentialsError?: string;
  userHintId?: string;
  isClientVerified?: boolean;
  isCredentialsLoading?: boolean;
  fixedValue?: string;
  provider: ProviderEntity;
  sourceAccountNumber?: string;
  isDesktop?: boolean;
  shouldShowUserHintId: boolean;
  isSplitFieldsProvider: boolean;
  bodyBlock: ReactNode;
  buttonLabel: ReactNode;
  onSubmit: (payload: SubmitProviderInputsPayload) => void;
};

export const LoginTemplatePayScreenView: React.FC<LoginTemplatePayScreenViewProps> = ({
  credentialsError,
  userHintId,
  isClientVerified,
  isCredentialsLoading,
  fixedValue,
  provider,
  shouldShowUserHintId,
  isSplitFieldsProvider,
  bodyBlock,
  buttonLabel,
  onSubmit,
}) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(true);

  const { formatMessage } = useIntl();
  const passwordHelpText = provider.passwordHelpText || formatMessage(messages.loginCredentialsTip);

  return (
    <ContentBody data-testid="login-template-screen-pay">
      <LoginTitleHeader passwordHelpText={passwordHelpText} />
      <HeaderContainer>
        <ProviderTitleHeader
          providerName={provider.displayName}
          iconSrc={Provider.getIcon(provider)}
        />
        {userHintId && (
          <StyledUserHintId>{shouldShowUserHintId ? userHintId : undefined}</StyledUserHintId>
        )}
      </HeaderContainer>

      {credentialsError && (
        <StyledError data-testid="credentials-error">{credentialsError}</StyledError>
      )}
      <ProviderInputsWrapper
        setButtonDisabled={setIsButtonDisabled}
        providerFields={provider.fields}
        fixedValue={fixedValue}
        onSubmit={onSubmit}
        renderProviderFields
        isSplitFields={isSplitFieldsProvider}
      >
        <ApplicationUnverifiedLabel isVerified={Boolean(isClientVerified)} />

        {bodyBlock}

        <Footer stickToBottom>
          {isCredentialsLoading ? (
            <LoadingSpinner />
          ) : (
            <Button
              disabled={isButtonDisabled}
              type="submit"
              color="primary"
              variant="contained"
              data-testid="submit-credentials-button"
              data-test="submitCredentialsButton"
            >
              {buttonLabel}
            </Button>
          )}
        </Footer>
      </ProviderInputsWrapper>
    </ContentBody>
  );
};
